<div class="custom-component">
  <nts-labelled-text-box [labelPosition]="'top'" #expandableChild
    [propertyViewModel]="viewModel.paymentDataViewModel.businessName">
  </nts-labelled-text-box>

  <nts-labelled-text-box [labelPosition]="'top'" #expandableChild
    [propertyViewModel]="viewModel.paymentDataViewModel.vatNumber">
  </nts-labelled-text-box>
</div>
